var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":_vm.color,"size":_vm.size}},[(_vm.imageSrc)?_c('img',{attrs:{"src":_vm.imageSrc,"alt":_vm.altText}}):_c('span',{staticClass:"white--text text-caption font-weight-medium"},[_vm._v(" "+_vm._s(_vm.fallbackTextValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }